package com.exura

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.MutablePalette
import com.varabyte.kobweb.silk.theme.colors.palette.Palette
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.link

object ChartsRawPastelPalette {

    fun Color.toCssRgba() : String {
        val orgRgb = this.toRgb()
        return "rgba(${orgRgb.red}, ${orgRgb.green}, ${orgRgb.blue}, ${orgRgb.alphaf})"
    }

    val BaseDark = Color.rgba(18, 18, 18, 1f)
    val BaseLight = Color.rgba(240, 240, 240, 1f)

    val Teal = Color.rgba(77, 182, 172, 1f)
    val Red = Color.rgba(229, 115, 115, 1f)
    val Blue = Color.rgba(100, 181, 246, 1f)
    val Orange = Color.rgba(255, 183, 77, 1f)
    val Grey = Color.rgba(117, 117, 117, 1f)
}


object ThemeRawPalette {
    // --- Brand Colors ---
    val PrimaryLight = Color.rgba(62, 118, 234, 1f)
    val PrimaryDark = Color.rgba(168, 199, 250, 1f)

    val SecondaryLight = Color.rgba(3, 218, 198, 1f)
    val SecondaryDark = Color.rgba(3, 218, 198, 1f)

    // --- Backgrounds (Category A) ---
    val BackgroundLight = Color.rgba(240, 240, 240, 1f)
    val BackgroundDark = Color.rgba(18, 18, 18, 1f)

    // --- Surfaces (Opinionated) ---
    val SurfaceLight = Color.rgba(245, 245, 245, 1f)
    val SurfaceDark = Color.rgba(30, 30, 30, 1f)

    // --- Text / Foreground (Category A) ---
    val OnBackgroundLight = Color.rgba(18, 18, 18, 1f)
    val OnBackgroundDark = Color.rgba(240, 240, 240, 1f)

    // --- Utilities (Category B) ---
    val BorderLight = Color.rgba(224, 224, 224, 1f)
    val BorderDark = Color.rgba(60, 60, 60, 1f)

    // --- Semantic / Feedback Colors ---
    val ErrorLight = Color.rgba(176, 0, 32, 1f)
    val ErrorDark = Color.rgba(207, 102, 121, 1f)

    val SuccessLight = Color.rgba(76, 175, 80, 1f)
    val SuccessDark = Color.rgba(129, 201, 149, 1f)

    val WarningLight = Color.rgba(255, 152, 0, 1f)
    val WarningDark = Color.rgba(255, 183, 77, 1f)

    // --- Links ---
    val LinkLight = Color.rgba(50, 100, 200, 1f)
    val LinkDark = Color.rgba(100, 160, 255, 1f)

    val Transparent = Colors.Transparent
}

// Primary
val Palette.primary: Color get() = this.getValue("primary")
var MutablePalette.primary: Color
    get() = this.getValue("primary")
    set(value) {
        this["primary"] = value
    }

// Secondary
val Palette.secondary: Color get() = this.getValue("secondary")
var MutablePalette.secondary: Color
    get() = this.getValue("secondary")
    set(value) {
        this["secondary"] = value
    }

// Surface
val Palette.surface: Color get() = this.getValue("surface")
var MutablePalette.surface: Color
    get() = this.getValue("surface")
    set(value) {
        this["surface"] = value
    }

// Error
val Palette.error: Color get() = this.getValue("error")
var MutablePalette.error: Color
    get() = this.getValue("error")
    set(value) {
        this["error"] = value
    }

// Success (New)
val Palette.success: Color get() = this.getValue("success")
var MutablePalette.success: Color
    get() = this.getValue("success")
    set(value) {
        this["success"] = value
    }

// Warning (New)
val Palette.warning: Color get() = this.getValue("warning")
var MutablePalette.warning: Color
    get() = this.getValue("warning")
    set(value) {
        this["warning"] = value
    }

val Palette.transparent: Color get() = this.getValue("transparent")
var MutablePalette.transparent: Color
    get() = this.getValue("transparent")
    set(value) {
        this["transparent"] = value
    }


@InitSilk
fun updateTheme(context: InitSilkContext) {
    with(context.theme.palettes) {

        // --- Light Mode ---
        light.apply {
            // Essentials
            background = ThemeRawPalette.BackgroundLight
            color = ThemeRawPalette.OnBackgroundLight
            border = ThemeRawPalette.BorderLight
            link.default = ThemeRawPalette.LinkLight
            link.visited = ThemeRawPalette.LinkLight

            // Custom Semantic Keys
            primary = ThemeRawPalette.PrimaryLight
            secondary = ThemeRawPalette.SecondaryLight
            surface = ThemeRawPalette.SurfaceLight
            error = ThemeRawPalette.ErrorLight
            success = ThemeRawPalette.SuccessLight
            warning = ThemeRawPalette.WarningLight

            transparent = ThemeRawPalette.Transparent
        }

        // --- Dark Mode ---
        dark.apply {
            // Essentials
            background = ThemeRawPalette.BackgroundDark
            color = ThemeRawPalette.OnBackgroundDark
            border = ThemeRawPalette.BorderDark
            link.default = ThemeRawPalette.LinkDark
            link.visited = ThemeRawPalette.LinkDark

            // Custom Semantic Keys
            primary = ThemeRawPalette.PrimaryDark
            secondary = ThemeRawPalette.SecondaryDark
            surface = ThemeRawPalette.SurfaceDark
            error = ThemeRawPalette.ErrorDark
            success = ThemeRawPalette.SuccessDark
            warning = ThemeRawPalette.WarningDark

            transparent = ThemeRawPalette.Transparent
        }
    }
}
